import React, { Fragment, useCallback, useState } from "react";
import Input from "../ui-components/Input";
import Toggle from "../ui-components/Toggle";
import Button from "../ui-components/Button";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import ServiceConfiguratorBlockVisibility from "./ServiceConfiguratorBlockVisibility";
import blocksSettings from "./blocksSettings";
import ServiceConfiguratorBlockInput from "./ServiceConfiguratorBlockInput";
import ServiceConfiguratorBlockExpressionConfigurator from "./ServiceConfiguratorBlockExpressionConfigurator";
import ServiceConfiguratorOpenBlockImage from "./ServiceConfiguratorOpenBlockImage";
import ServiceConfiguratorAlertTCS from "./ServiceConfiguratorAlertTCS";
import CloseIcon from "./CloseIcon";
import Select from "../ui-components/Select";
import ServiceConfiguratorExpressionMarker from "./ServiceConfiguratorExpressionMarker";
import SelectProduct from "./SelectProduct";
import { isValidRecursiveQuestion } from "../utils/blockValidation";
import SelectSystem from "./SelectSystem";
import CheckboxGroup from "@ui-components/CheckboxGroup";
import Alert from "@ui-components/Alert";
import SearchSelect from "../ui-components/SearchSelect";
import {FormattedMessage, useIntl} from "react-intl";
import ServiceConfiguratorCompositeQuestionFieldSelector from "@components/ServiceConfiguratorCompositeQuestionFieldSelector";
import ServiceConfiguratorCompositeOutputPathSelector from "@components/ServiceConfiguratorCompositeOutputPathSelector";
import RadioGroup from "@ui-components/RadioGroup";

import { LOGIC_QTYPE } from "@feature/services/associate-services-logic/lib/consts"
import { PrepopulationLogicRulesEditor } from "@feature/services/associate-services-logic/prepopulation-logic-rules-editor";
import { RuleConfigurator } from "@feature/services/associate-services-logic/rule-configurator";
import {
  RecursiveQuestionsColumnMapper
} from "@feature/services/associate-services-logic/recursive-questions-column-mapper";
import { ServiceConfiguratorSelectServiceComponent } from "@components/ServiceConfiguratorSelectServiceComponent"
import {
  useCrossServicesConfigurations
} from "../feature/cross_services_configurations/hooks/useCrossServicesConfigurations";

const ServiceConfiguratorOpenBlock = ({
  setOpenBlock,
  block,
  fetchConfiguration,
  roleTypes,
  setDeleteBlock,
  second = "right-0",
  setCreateTranslation,
  serviceLocale,
  version,
  fetchServiceVersions,
  service,
  fetchCrossServicesConfigurations,
  ...rest
}) => {
  const [newData, setNewData] = useState(_.cloneDeep(block));
  const intl = useIntl();
  const {upsertCrossServicesConfiguration} = useCrossServicesConfigurations();
  const settings = blocksSettings[block.type];
  const countryApiRequest = useCountryAxiosInstance();
  const [submitting, setSubmitting] = useState(false);
  const [showDependencies, setShowDependencies] = useState(false);
  const [openAssociationRuleIdx, setOpenAssociationRuleIdx] = useState(undefined);

  const generateBaseOriginalExpression = () => {
    return [JSON.stringify({
      original: "original_expression",
      serviceBlockId: rest.openBlockServiceBlock.id,
      blockId: block.id,
    })];
  }

  /*
    NICE SPAGHETTI CODE ALERT!! thanks to requirements changing last minute
    this function generates the original expressions for products dependencies in k_color_input questions
    to be used in cross service configurations (when dependencies must be edited from a different service than the one the block belongs to)
   */
  const generateKColorProductsOriginalExpressions = (products_dependencies) => {
    const expressions = {};
    Object.entries(products_dependencies).forEach(([key, value]) => {
      expressions[key] = {
        /*
        HUBSPOT TICKET 37436679835
        we were missing to retrieve dependencies and disabled for each package inside each product dependency!!!
         */
        ...Object.keys(value).filter(k => k !== 'disabled' && k !== 'dependencies').reduce((acc, packageQty) => {
          acc[packageQty] = {
            ...value[packageQty],
            dependencies: [JSON.stringify({
              original: "original_expression",
              serviceBlockId: rest.openBlockServiceBlock.id,
              blockId: block.id,
              isKcolorPackagesDependency: true,
              KcolorProductAccessKey: key,
              KcolorPackageAccessKey: packageQty,
            })]
          }
          return acc;
        }, {}),
        dependencies:[JSON.stringify({
          original: "original_expression",
          serviceBlockId: rest.openBlockServiceBlock.id,
          blockId: block.id,
          isKcolorProductsDependency: true,
          KcolorProductAccessKey: key,
        })],
        disabled: value.disabled || false
      }
    })
    return expressions;
  }


  const fixCrossConfigurationDataForKColor = (crossConfigurationData) => {
    if (block?.type === 'question' && block?.input_type === 'k_color_input') {
      return {
        ...crossConfigurationData,
        /*
        HUBSPOT TICKET 32672875419
        when loading an existing cross service configuration, we need to ensure that
        the version is updated to the current version we are in.
        */
        version: version,
        metadata_: {
          colorsException: block.metadata_?.colorsException,
          products_dependencies: crossConfigurationData.metadata_?.products_dependencies
        }
      }
    } else {
      return {
        ...crossConfigurationData,
        /*
        HUBSPOT TICKET 32672875419
        when loading an existing cross service configuration, we need to ensure that
        the version is updated to the current version we are in.
        */
        version: version,
      };
    }
  }

  const availableBusiness = [
    { label: "Kerakoll", value: 1 },
    { label: "Knauf", value: 2 },
  ];
  const [selectedBusiness, setSelectedBusiness] = useState({
    label: "Kerakoll",
    value: 1,
  });
  const isFromDifferentService = block.service_id !== service.id;
  const crossConfigurationData = isFromDifferentService ? rest.crossData.find(
    (cd) => cd.block_id === block.id && cd.service_block_id === rest.openBlockServiceBlock.id
  ) : null;

  const [newCrossConfigurationData, setNewCrossConfigurationData] = useState(
    isFromDifferentService ?
      crossConfigurationData ?
        _.cloneDeep(fixCrossConfigurationDataForKColor(crossConfigurationData)) :
        {
          block_id: block.id,
          service_block_id: rest.openBlockServiceBlock.id,
          block_version: block.version,
          service_block_version: rest.openBlockServiceBlock.version,
          version: version,
          dependencies: block.dependencies.length > 0 ?   generateBaseOriginalExpression() : [],
          ...(block.calculation?.length > 0 ?
            {calculation: generateBaseOriginalExpression()} : {}),
          r_perm: block.r_perm,
          w_perm: block.w_perm,
          // for now only handle k_color_input metadata modularization
          ...(block?.type === 'question' && block.input_type === 'k_color_input' ? {
              // controllare perché non vedo le eccezioni!
              metadata_: {
                ...block.metadata_,
                products_dependencies: generateKColorProductsOriginalExpressions(block.metadata_?.products_dependencies || {})
              }
            } : {})
        }
      : null
  )

  const updateCrossServiceConfiguration = useCallback(async () => {
    const {id, ...payload} = newCrossConfigurationData;
    const dataToUpsert = crossConfigurationData && version
    && (version > crossConfigurationData.version) ? payload : newCrossConfigurationData;
    return await upsertCrossServicesConfiguration(dataToUpsert);
  }, [newCrossConfigurationData, countryApiRequest, crossConfigurationData]);

  const updateBlock = useCallback(async () => {

    // utility function to update a block via API
    const updateConfiguration = (id, payload) => countryApiRequest.put(
      `/services_configurations/${id}/version/${version}`,
      payload,
    );

    const createNewVersion = async (payload) => {
      return countryApiRequest.post(
        `/services_configurations`,
        payload,
      );
    }

    // save changes
    if (version && (version > block.version)) {
      const payload = {
        ...newData,
        version: version,
        flg_output_visibility: newData.type === 'output' ? newData.flg_output_visibility : null,
        flg_subtotal: newData.type === 'output' && newData.output_currency ? newData.flg_subtotal : false,
      }
      return await createNewVersion(payload);
    } else {
      const payload = {
        ...newData,
        flg_output_visibility: newData.type === 'output' ? newData.flg_output_visibility : null,
        flg_subtotal: newData.type === 'output' && newData.output_currency ? newData.flg_subtotal : false,
      };
      return await updateConfiguration(block.id, payload);
    }


  }, [newData, countryApiRequest, block]);

  const questions = rest.data.filter(
    (d) => d.type === "question" && d.input_type && d.id !== block.id
  );
  const outputs = rest.data.filter(
    (d) => d.type === "output" && d.id !== block.id
  );
  const currentInputOptions = rest.data.filter(
    (d) => d.type === "option" && d.input_id === block.id
  );
  const recursiveQuestions = rest.data.filter((d) =>
    isValidRecursiveQuestion(d)
  );

  const associatedDesignServices = rest.associatedDesignServices;

  const isAssociationLogicBlocked =
    // Association with design services must be blocked if
    // A. The current block is a question inside a recursive question which already has an association logic
    (
      newData.type === "question"
      && !!rest.data.find((({id, type}) =>
        type === "recursive_question"
        && id === newData.recursive_question_id
      ))?.design_survey_prepopulation_logic
    )
    // B. The current block is a recursive question, whose at least one inner question has an association logic
    || (
      newData.type === "recursive_question"
      && !!rest.data
        .filter((({recursive_question_id, type}) =>
          type === "question"
          && recursive_question_id === newData.id
        ))
        .some((q) => !!q?.design_survey_prepopulation_logic)
    );

  const onCloseLogicEditor = (skipPrompt) => {
    if (!skipPrompt) {
      const proceed = confirm(intl.formatMessage({id: "close_without_save_prompt"}));
      if (!proceed)
        return;
    }
    setOpenAssociationRuleIdx(undefined);
  }
  const logicEditorSave = (element, target) => {
    setNewData((prev) => {
      const targetArr = prev.design_survey_prepopulation_logic?.[target] || [];
      if (typeof openAssociationRuleIdx === "number")
        targetArr[openAssociationRuleIdx] = element;
      else
        targetArr.push(element);
      return {
        ...prev,
        design_survey_prepopulation_logic: {
          ...prev.design_survey_prepopulation_logic,
          [target]: targetArr
        },
      };
    });
    setOpenAssociationRuleIdx(undefined);
  }
  const deleteAssociationRuleByIdx = (idx) => {
    const generateEdit = (prev) => {
      if (
        !prev?.design_survey_prepopulation_logic
        || !["simple", "recursive_copy"].includes(prev.design_survey_prepopulation_logic.type)
      )
        return {};
      const target = prev.design_survey_prepopulation_logic.type === "simple"
        ? "rules"
        : "recursive_copy_settings";
      return {
        [target]: prev.design_survey_prepopulation_logic[target].filter((_, i) => i !== idx),
      };
    }
    setNewData((prev) => ({
      ...prev,
      design_survey_prepopulation_logic: {
        ...prev.design_survey_prepopulation_logic,
        ...generateEdit(prev),
      },
    }));
  }


  return (
    <div
      className={`animate-slideIn w-1/2 lg:w-1/3 fixed inset-y-0 right-0 bg-white overflow-y-auto pl-4 pr-4 pt-2 shadow-2xl pb-6 ${second}`}
    >
      {newData.design_survey_prepopulation_logic?.type === "simple" && openAssociationRuleIdx !== undefined && (
        <RuleConfigurator
          question={block}
          rule={newData.design_survey_prepopulation_logic.rules[openAssociationRuleIdx] || null}
          questionOptions={currentInputOptions}
          designServices={associatedDesignServices}
          onClose={onCloseLogicEditor}
          onSave={(rule) => { logicEditorSave(rule, "rules"); }}
          service={service}
        />
      )}
      {newData.design_survey_prepopulation_logic?.type === "recursive_copy" && openAssociationRuleIdx !== undefined && (
        <RecursiveQuestionsColumnMapper
          mapping={newData.design_survey_prepopulation_logic.recursive_copy_settings[openAssociationRuleIdx] || null}
          innerQuestions={questions.filter((q) => q.recursive_question_id === block.id)}
          designServices={associatedDesignServices}
          serviceConfigurations={rest.data}
          onClose={onCloseLogicEditor}
          onSave={(mapping) => { logicEditorSave(mapping, "recursive_copy_settings"); }}
        />
      )}
      {showDependencies ? (
        <ServiceConfiguratorBlockExpressionConfigurator
          setShowDependencies={setShowDependencies}
          fullExpression={
            isFromDifferentService ?
              newCrossConfigurationData?.[showDependencies] :
              newData[showDependencies]
          }
          newData={isFromDifferentService ? newCrossConfigurationData : newData}
          setNewData={isFromDifferentService? setNewCrossConfigurationData : setNewData}
          block={block}
          questions={questions}
          recursiveQuestions={recursiveQuestions}
          outputs={rest.data.filter(
            (d) =>
              d.type === "output" &&
              ["calculation", "json_output_value"].includes(d.output_type) &&
              d.id !== block.id
          )}
          data={rest.data}
          type={showDependencies}
          service={service}
          {...rest}
          />
      ) : null}
      {openAssociationRuleIdx === undefined && !showDependencies && (
        <Fragment>
          <CloseIcon
            onClick={() => {
              setOpenBlock(null);
            }}
          />

          {settings?.blocks?.image ? (
            <ServiceConfiguratorOpenBlockImage
              image={newData.image_filename}
              onChange={(name) => {
                setNewData({ ...newData, image_filename: name });
              }}
              newData={newData}
              editable={!isFromDifferentService}
            />
          ) : null}
          {block.type === "recursive_question" && (
            <Fragment>
              <Toggle
                label=<FormattedMessage id="table_mode" />
                checked={newData.metadata_?.table_mode}
                disabled={isFromDifferentService}
                onChange={() =>
                  setNewData({
                    ...newData,
                    metadata_: {
                      ...newData.metadata_,
                      table_mode:
                        newData.metadata_?.table_mode === undefined
                          ? true
                          : !newData.metadata_?.table_mode,
                    },
                  })
                }
              />
            </Fragment>
          )}
          {(block.type === "recursive_question" ||
            (block.type === "question" &&
              block.input_type === "node_reinforcement_input")) && (
            <Fragment>
              <Toggle
                label=<FormattedMessage id="attach_to_tcs" />
                checked={newData.attach_to_tcs}
                disabled={isFromDifferentService}
                onChange={() =>
                  setNewData({
                    ...newData,
                    attach_to_tcs: !newData.attach_to_tcs,
                  })
                }
              />
            </Fragment>
          )}
          {block.type === "option" && (
            <SearchSelect
              isDisabled={isFromDifferentService}
              label="Seleziona l'azienda" // usare intl con le traduzioni
              options={availableBusiness}
              value={selectedBusiness}
              onChange={setSelectedBusiness}
            />
          )}

          {settings?.blocks?.product ? (
            <SelectProduct
              disabled={isFromDifferentService}
              businessId={selectedBusiness?.value}
              location={"OpenBlock"}
              value={
                newData.product_id
                  ? {
                      value: newData.product_id,
                      label:
                        newData?.product?.art_des_cmpy ||
                        `Product ${newData.product_id}`,
                    }
                  : { value: "", label: "" }
              }
              onChange={(e) => {
                setNewData({
                  ...newData,
                  product_id: e.value || null,
                  ...(e.value ? { product: { art_des_cmpy: e.label } } : {}),
                });
              }}
            />
          ) : null}

          {settings?.blocks?.system ? (
            <SelectSystem
              disabled={isFromDifferentService}
              value={
                newData.system_id
                  ? {
                      value: newData.system_id,
                      label:
                        newData?.system?.ciclo ||
                        `System - ${newData.system_id}`,
                    }
                  : { value: "", label: "" }
              }
              onChange={(e) => {
                setNewData({
                  ...newData,
                  system_id: e.value || null,
                  ...(e.value ? { system: { ciclo: e.label } } : {}),
                });
              }}
            />
          ) : null}

          {settings?.blocks?.option_value ? (
            <Input
              disabled={isFromDifferentService}
              value={newData.option_value}
              onChange={(e) => {
                setNewData({ ...newData, option_value: e.target.value });
              }}
              label={"Value"}
              type="text"
            />
          ) : null}
          {settings?.blocks?.name ? (
            <Input
              value={newData.name}
              onChange={(e) => {
                setNewData({ ...newData, name: e.target.value });
              }}
              label={"Name"}
              type="text"
              disabled={isFromDifferentService}
            />
          ) : null}
          {settings?.blocks?.title ? (
            <Input
              value={newData.title}
              onChange={(e) => {
                setNewData({ ...newData, title: e.target.value });
              }}
              label={
                settings?.blocks?.outputType && newData.output_type === "link"
                  ? "Link Title"
                  : "Title"
              }
              type="text"
              checkTranslation={setCreateTranslation}
              translations={serviceLocale}
              disabled={isFromDifferentService}
            />
          ) : null}

          {settings?.blocks?.description ? (
            <Input
              value={newData.description}
              onChange={(e) => {
                setNewData({ ...newData, description: e.target.value });
              }}
              label={
                settings?.blocks?.outputType && newData.output_type === "link"
                  ? "Link"
                  : "Description"
              }
              type="text"
              checkTranslation={setCreateTranslation}
              translations={serviceLocale}
              disabled={isFromDifferentService}
            />
          ) : null}
          {block.type === 'service' ? (
            <ServiceConfiguratorSelectServiceComponent
              value={newData.metadata_?.chosen_service_id}
              onChange={(e) => {
                setNewData({ ...newData,
                  metadata_: {
                    chosen_service_id: e.value
                  }
                });
              }}
              services={rest.services}
            />
          ) : null}
          {block.recursive_question_id ? (
            <Input
              disabled={isFromDifferentService}
              value={newData.column_name}
              onChange={(e) => {
                setNewData({ ...newData, column_name: e.target.value });
              }}
              label={"Column name"}
              type="text"
              checkTranslation={setCreateTranslation}
              translations={serviceLocale}
            />
          ) : null}
          {settings?.blocks?.input ? (
            <ServiceConfiguratorBlockInput
              newData={newData}
              setNewData={setNewData}
              newCrossData={newCrossConfigurationData}
              setNewCrossData={setNewCrossConfigurationData}
              editable={!isFromDifferentService}
              setShowDependencies={setShowDependencies}
              block={block}
              questions={questions}
              recursiveQuestions={recursiveQuestions}
              outputs={rest.data.filter(
                (d) =>
                  d.type === "output" &&
                  ["calculation", "json_output_value"].includes(d.output_type) &&
                  d.id !== block.id
              )}
              data={rest.data}
              type={showDependencies}
              service={service}
              {...rest}
            />
          ) : null}
          {settings?.blocks?.alertType ? (
            <>
              <Select
                label="Alert type"
                disabled={isFromDifferentService}
                options={[
                  { value: "", name: "" },
                  { value: "success", name: "Success" },
                  { value: "error", name: "Error" },
                  { value: "info", name: "Information" },
                  { value: "warning", name: "Warning" },
                  { value: "image", name: "Image" },
                  // Le classi di tcs saranno due: kerakoll oppure il partner
                  { value: "tcs", name: "TCS" },
                ]}
                value={newData.alert_type || ""}
                onChange={(e) => {
                  const alertType = e.target.value;
                  const tcsMetadata = {
                    tcsType: 'kerakoll',
                    webCategoriaProdotto: '',
                    webMotivoContatto:'',
                    alertText: '',
                    emailBody: '',
                    recipientEmail: '',
                    questions:[]
                  }

                  setNewData({
                    ...newData,
                    ...(alertType === "tcs" ? { metadata_: tcsMetadata } : {}),
                    alert_type: alertType,
                  });
                }}
              />
              {newData.alert_type === "tcs" && (
                <ServiceConfiguratorAlertTCS 
                metadata_={newData.metadata_}
                setMetadata={(newMetadata_)=>{
                    setNewData({
                      ...newData,
                      metadata_:newMetadata_
                    })
                  }}
                />)}
            </>
          ) : null}
          {settings?.blocks?.outputType ? (
            <Fragment>
              <Select
                label="Output type"
                disabled={isFromDifferentService}
                options={[
                  { value: "", name: "" },
                  { value: "calculation", name: "Calculation" },
                  { value: "question", name: "Question answer" },
                  { value: "json_output_value", name: "Composite output part" },
                  { value: "text_image", name: "Text/Image" },
                  { value: "link", name: "Link" },
                  { value: "separator", name: "Separator" },
                ]}
                value={newData.output_type || ""}
                onChange={(e) => {
                  const t = e.target.value;
                  setNewData((prev) => ({
                    ...newData,
                    output_type: t,
                    metadata_:
                      t === "json_output_value" ? prev.metadata_ : undefined,
                  }));
                }}
              />
              {newData?.output_type === "calculation" ? (
                <ServiceConfiguratorExpressionMarker
                  onClick={() => {
                    setShowDependencies("calculation");
                  }}
                  title="Calculation"
                  setted={newData?.calculation?.length}
                />
              ) : null}
              {newData?.output_type === "question" && (
                <>
                  <Select
                    label="Output question"
                    options={[
                      { value: "", name: "" },
                      ...questions.map((q) => ({
                        name: q.name || `Question ${q.id}`,
                        value: q.id,
                      })),
                    ]}
                    value={newData.output_input_id || ""}
                    onChange={(e) => {
                      setNewData({
                        ...newData,
                        output_input_id: parseInt(e.target.value),
                      });
                    }}
                  />
                  <ServiceConfiguratorCompositeQuestionFieldSelector
                    label="Output question field"
                    selectedQuestionId={newData.output_input_id}
                    questions={questions}
                    onChange={(e) => {
                      setNewData((prev) => ({
                        ...prev,
                        metadata_: {
                          ...(prev.metadata_ || {}),
                          field: e.target.value,
                        },
                      }));
                    }}
                    value={newData.metadata_?.field || ""}
                  />
                </>
              )}
              {newData?.output_type === "json_output_value" && (
                <>
                  <Select
                    label="Select target output"
                    options={[
                      { value: "", name: "" },
                      ...outputs
                        .filter(
                          ({ output_type, calculation }) =>
                            // select only outputs with composite values
                            output_type === "calculation" &&
                            calculation?.length === 1 &&
                            calculation[0].startsWith("{") &&
                            (JSON.parse(calculation[0]).original === "connector" ||
                              JSON.parse(calculation[0]).original === "spreadsheet")
                        )
                        .map(({ id, name }) => ({ name, value: id })),
                    ]}
                    value={newData.output_input_id || ""}
                    onChange={(e) => {
                      setNewData((prev) => ({
                        ...prev,
                        output_input_id: parseInt(e.target.value),
                      }));
                    }}
                  />
                  <ServiceConfiguratorCompositeOutputPathSelector
                    label="Select value"
                    editable={!isFromDifferentService}
                    selectedOutputId={newData.output_input_id}
                    outputs={outputs}
                    onChange={(path) => {
                      setNewData((prev) => ({
                        ...prev,
                        metadata_: {
                          ...(prev.metadata_ || {}),
                          path: path,
                        },
                      }));
                    }}
                    value={newData.metadata_?.path}
                  />
                </>
              )}
              {newData.output_type === "separator" ? (
                <Select
                  label="Separator Type"
                  options={[
                    { value: 0, name: "Space" },
                    { value: 1, name: "One line" },
                    { value: 2, name: "Double line" },
                    { value: 3, name: "Double bold line" },
                  ]}
                  value={newData.output_input_id || 0}
                  onChange={(e) => {
                    setNewData({
                      ...newData,
                      output_input_id: e.target.value,
                    });
                  }}
                />
              ) : null}
              {newData.output_type !== "link" ? (
                <Fragment>
                  <RadioGroup
                    disabled={isFromDifferentService}
                    id="output-thickness-rg"
                    name="output-thickness-rg"
                    title="Output thickness"
                    options={[
                      { name: "Slim", value: 1 },
                      { name: "Normal", value: 2 },
                      { name: "Large", value: 3 },
                    ]}
                    currentValue={newData.output_thickness}
                    onChange={(selected) => {
                      setNewData({
                        ...newData,
                        output_thickness: selected,
                      });
                    }}
                    horizontal
                    inline
                  />
                  <Toggle
                    disabled={isFromDifferentService}
                    label="Output currency"
                    checked={newData.output_currency}
                    onChange={() =>
                      setNewData({
                        ...newData,
                        output_currency: !newData.output_currency,
                      })
                    }
                  />
                  {newData.output_currency && (
                    <div className="border-l ml-4 pl-4 flex flex-col">
                      <Toggle
                        disabled={isFromDifferentService}
                        label="Subtotal"
                        checked={newData.flg_subtotal}
                        onChange={() => {
                          setNewData((prev) => ({
                            ...prev,
                            flg_subtotal: !prev.flg_subtotal,
                          }));
                        }}
                        marginCls=""
                      />
                    </div>
                  )}
                  <Toggle
                    label="Output ceil"
                    disabled={isFromDifferentService}
                    checked={newData.output_ceil}
                    onChange={() =>
                      setNewData({
                        ...newData,
                        output_ceil: !newData.output_ceil,
                      })
                    }
                  />
                </Fragment>
              ) : null}
            </Fragment>
          ) : null}

          {settings?.blocks?.dependencies ? (
            <ServiceConfiguratorExpressionMarker
              onClick={() => {
                setShowDependencies("dependencies");
              }}
              title="Dependencies"
              setted={
                isFromDifferentService ?
                  newCrossConfigurationData?.dependencies?.length :
                  newData.dependencies?.length
              }
            />
          ) : null}

          {["question", "recursive_question"].includes(newData.type)
            && Object.keys(service.associated_services).length > 0
            && service.class === 1 // is quotation
            && (
              <div className="mt-4 mb-6 flex flex-col gap-2">
                <RadioGroup
                  horizontal
                  id="building-owner-type"
                  title={(
                    <span className="font-bold text-black">
                      <FormattedMessage
                        id="question_association_type"
                        defaultMessage="Associazione tra domande"
                      />
                    </span>
                  )}
                  options={LOGIC_QTYPE.map((q) => ({
                    name: intl.formatMessage({ id: q }),
                    value: q,
                  }))}
                  currentValue={
                    !newData.design_survey_prepopulation_logic || isAssociationLogicBlocked
                      ? "none_f"
                      : "logic_from_design"
                  }
                  onChange={(selected) => {
                    const logic = {
                      type: newData.type === "question" ? "simple" : "recursive_copy",
                      rules: newData.type === "question" ? [] : undefined,
                      recursive_copy_settings: newData.type === "question" ? undefined : [],
                    };
                    setNewData({
                      ...newData,
                      design_survey_prepopulation_logic: selected === "none_f" ? null : logic,
                    });
                  }}
                  disabled={isAssociationLogicBlocked}
                />

                {isAssociationLogicBlocked && (
                  <Alert
                    type="warning"
                    title={intl.formatMessage({
                      id: "question_association_logic_blocked_title",
                      defaultMessage: "Perché non è possibile associare questa domanda?",
                    })}
                    text={
                      newData.type === "question"
                        ? intl.formatMessage({
                          id: "question_association_logic_blocked",
                          defaultMessage:
                            "L'associazione tra domande è bloccata per questa domanda perché fa parte " +
                            "di una domanda ricorsiva che ha già una associazione. Per poterla modificare, rimuovere " +
                            "l'associazione dalla domanda ricorsiva",
                        })
                        : intl.formatMessage({
                          id: "recursive_question_association_logic_blocked",
                          defaultMessage:
                            "L'associazione tra domande è bloccata per questa domanda ricorsiva perché almeno " +
                            "una delle domande interne ha già una associazione. Per poterla modificare, rimuovere " +
                            "l'associazione dalle domande interne",
                        })
                    }
                  />
                )}

                {!!newData.design_survey_prepopulation_logic && (
                  <PrepopulationLogicRulesEditor
                    questionOptions={currentInputOptions}
                    logic={newData.design_survey_prepopulation_logic}
                    onAdd={() => {
                      setOpenAssociationRuleIdx(null);
                    }}
                    onEdit={(idx) => {
                      setOpenAssociationRuleIdx(idx);
                    }}
                    onDelete={(idx) => {
                      deleteAssociationRuleByIdx(idx);
                    }}
                    designServices={associatedDesignServices}
                  />
                )}
              </div>
            )
          }

          {settings?.blocks?.hidden ? (
            <ServiceConfiguratorBlockVisibility
              roleTypes={roleTypes}
              newData={newData}
              setNewData={setNewData}
              blockKey="hidden_question"
              editable={!isFromDifferentService}
            />
          ) : null}
          {/*<ServiceConfiguratorBlockVisibility*/}
          {/*  roleTypes={roleTypes}*/}
          {/*  newData={newData}*/}
          {/*  setNewData={setNewData}*/}
          {/*/>*/}

          {settings?.blocks?.required ? (
            <Toggle
              disabled={isFromDifferentService}
              label="Required"
              checked={newData.required}
              onChange={() =>
                setNewData({ ...newData, required: !newData.required })
              }
            />
          ) : null}

          <Toggle
            label="Active"
            checked={
              isFromDifferentService &&
                ![null, undefined].includes(newCrossConfigurationData.active)?
                  newCrossConfigurationData.active:
                newData.active
            }
            onChange={(e) => {
              if (isFromDifferentService) {
                setNewCrossConfigurationData({
                  ...newCrossConfigurationData,
                  active: e
                });
              } else {
                setNewData({ ...newData, active: !newData.active })
              }
            }}
          />

          {!!settings?.blocks?.pdfOptions && (
            <div className="border-l ml-4 pl-4 flex flex-row items-center justify-between gap-4">
              <p>Show inside</p>
              <div className="mt-2 w-32">
                <CheckboxGroup
                  options={[{name: "WEB", value: 0x1}, {name: "PDF", value: 0x2}]}
                  values={
                    isFromDifferentService  &&
                      ![null, undefined].includes(newCrossConfigurationData.flg_output_visibility) ?
                        [0x1, 0x2].filter(v => (newCrossConfigurationData.flg_output_visibility & v) > 0):
                        [0x1, 0x2].filter(v => (newData.flg_output_visibility & v) > 0)
                  }
                  onChange={(v) => {
                    if (isFromDifferentService) {
                      setNewCrossConfigurationData((prev) => ({
                        ...prev,
                        flg_output_visibility:
                          [null, undefined].includes(prev.flg_output_visibility) ?
                            (newData.flg_output_visibility || 0) ^ v :
                          (prev.flg_output_visibility || 0) ^ v,
                      }));
                    } else {
                      setNewData((prev) => ({
                        ...prev,
                        flg_output_visibility: (prev.flg_output_visibility || 0) ^ v,
                      }));
                    }
                  }}
                  horizontal
                />
              </div>
            </div>
          )}

          <div className="flex w-full justify-between mt-8">
            <Button
              disabled={isFromDifferentService}
              styleType="danger"
              submitting={submitting}
              onClick={() => {
                setDeleteBlock(block);
              }}
            >
              DELETE
            </Button>
            <Button
              submitting={submitting}
              onClick={async () => {
                try {
                  setSubmitting(true);
                  if (isFromDifferentService) {
                    await updateCrossServiceConfiguration();
                    await fetchCrossServicesConfigurations();
                    await fetchServiceVersions();
                    setOpenBlock(null);
                  } else {
                    await updateBlock();
                    await fetchConfiguration();
                    await fetchServiceVersions();
                    setOpenBlock(null);
                  }
                  // setOpenBlock(null);
                } catch (error) {
                  console.log(error);
                  setSubmitting(false);
                }
              }}
            >
              SAVE
            </Button>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default ServiceConfiguratorOpenBlock;
